var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay"},[_c('img',{staticClass:"overlay-loader loading-spinner",attrs:{"src":_vm.CONSTANTS.SPINNER_URL,"alt":"Loading Spinner"}})])}
var staticRenderFns = []

export { render, staticRenderFns }